import {Component, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ReplaySubject} from 'rxjs';
import {Model} from '../../../../../domain/model/common/model.class';
import {ActivatedRoute} from '@angular/router';
import {FormErrors} from '../../../../../components/forms/validation/form-validator.class';
import {StepScreenModel} from '../../../../shared/step/step-screen.component';
import {FileLocation, FileLocationFactory} from '../../../../../components/files/service/file-location.class';
import {AbmsBoardSubspecialtyService} from '../../../../../domain/model/licenses-certifications/board/abms/subspecialty/abms-board-subspecialty.service';
import {AbmsBoardSubspecialty} from '../../../../../domain/model/licenses-certifications/board/abms/subspecialty/abms-board-subspecialty.model';
import {AbmsBoardSubspecialtyScreensManager} from './abms-board-subspecialty-screens-manager.service';
import {AbmsBoardService} from '../../../../../domain/model/licenses-certifications/board/abms/abms-board.service';
import moment = require('moment');
import ProjectionInformation = Model.ProjectionInformation;
import { VerificationService } from '../../../../../components/verification/service/verification.service';

@Component({
    template: require('./abms-board-subspecialty-screen.component.html')
})
export class AbmsBoardSubspecialtyScreenComponent {

    constructor(readonly modelService: AbmsBoardSubspecialtyService,
                readonly abmsBoardService: AbmsBoardService,
                readonly route: ActivatedRoute,
                readonly screensManager: AbmsBoardSubspecialtyScreensManager,
                readonly fileLocationFactory: FileLocationFactory,
                readonly verificationService: VerificationService) {}

    // region Form
    readonly form$ = new ReplaySubject<NgForm>(1);

    @ViewChild(NgForm) set form(value: NgForm) {
        this.form$.next(value);
    }

    // endregion

    certifications: Array<string> = [
        'Addiction Medicine',
        'Addiction Psychiatry',
        'Adolescent Medicine',
        'Adult Congenital Heart Disease',
        'Advanced Heart Failure and Transplant Cardiology',
        'Anesthesiology Critical Care Medicine',
        'Blood Banking/Transfusion Medicine',
        'Brain Injury Medicine',
        'Cardiovascular Disease',
        'Child Abuse Pediatrics',
        'Child and Adolescent Psychiatry',
        'Clinical Cardiac Electrophysiology',
        'Clinical Informatics',
        'Clinical Neurophysiology',
        'Complex General Surgical Oncology',
        'Congenital Cardiac Surgery',
        'Critical Care Medicine',
        'Cytopathology',
        'Dermatopathology',
        'Developmental-Behavioral Pediatrics',
        'Emergency Medical Services',
        'Endocrinology, Diabetes and Metabolism',
        'Epilepsy',
        'Female Pelvic Medicine and Reconstructive Surgery',
        'Forensic Psychiatry',
        'Gastroenterology',
        'Geriatric Medicine',
        'Gynecologic Oncology',
        'Hematology',
        'Hematopathology',
        'Hospice and Palliative Medicine',
        'Infectious Disease',
        'Internal Medicine-Critical Care Medicine',
        'Interventional Cardiology',
        'Maternal and Fetal Medicine',
        'Medical Biochemical Genetics',
        'Medical Oncology',
        'Medical Toxicology',
        'Molecular Genetic Pathology',
        'Neonatal-Perinatal Medicine',
        'Nephrology',
        'Neurodevelopmental Disabilities',
        'Neuromuscular Medicine',
        'Neuropathology',
        'Neurotology',
        'Nuclear Radiology',
        'Orthopaedic Sports Medicine',
        'Pain Medicine',
        'Pathology - Chemical',
        'Pathology - Forensic',
        'Pathology - Medical Microbiology',
        'Pathology - Molecular Genetic',
        'Pathology - Pediatric',
        'Pediatric Anesthesiology',
        'Pediatric Cardiology',
        'Pediatric Critical Care Medicine',
        'Pediatric Dermatology',
        'Pediatric Emergency Medicine',
        'Pediatric Endocrinology',
        'Pediatric Gastroenterology',
        'Pediatric Hematology-Oncology',
        'Pediatric Hospital Medicine',
        'Pediatric Infectious Diseases',
        'Pediatric Nephrology',
        'Pediatric Otolaryngology',
        'Pediatric Pulmonology',
        'Pediatric Radiology',
        'Pediatric Rehabilitation Medicine',
        'Pediatric Rheumatology',
        'Pediatric Surgery',
        'Pediatric Transplant Hepatology',
        'Pediatric Urology',
        'Plastic Surgery Within the Head and Neck',
        'Psychosomatic Medicine',
        'Pulmonary Disease',
        'Reproductive Endocrinology/Infertility',
        'Rheumatology',
        'Sleep Medicine',
        'Spinal Cord Injury Medicine',
        'Sports Medicine',
        'Surgery of the Hand',
        'Surgical Critical Care',
        'Transplant Hepatology',
        'Undersea and Hyperbaric Medicine',
        'Vascular and Interventional Radiology',
        'Vascular Neurology'
    ];

    certificationDateConstrains = {
        min: moment().subtract(100, 'year'),
        max: moment().add(5, 'year')
    };
    supportingDocumentFileLocation: FileLocation;

    get abmsIndex(): number {
        return +this.route.snapshot.params['abmsIndex'];
    }

    get index(): number {
        return +this.route.snapshot.params['index'];
    }

    abmsBoardCertificate?: string;

    stepScreenModel = new StepScreenModel<AbmsBoardSubspecialty>({
        initialDataModel: new AbmsBoardSubspecialty(),
        specificValidationMessages: {},
        screensManager: this.screensManager,
        _loadDataFn: () => {
            this.abmsBoardService.getCurrentUserModelEntry(this.abmsIndex).subscribe(abmsBoard => this.abmsBoardCertificate = abmsBoard!.certificate);
            this.supportingDocumentFileLocation = this.fileLocationFactory.create('abmsBoard', `currentUser/${this.abmsIndex}/sub/${this.index}`, new ProjectionInformation('supportingDocument'));
            this.verificationService.setUrl('abmsBoard', undefined, `${this.abmsIndex}/sub/${this.index}`);
            return this.modelService.getCurrentUserModelEntry(this.abmsIndex, this.index);
        },
        _submitDataFn: (model: AbmsBoardSubspecialty) => {
            return this.modelService.updateCurrentUserModelEntry(this.abmsIndex, this.index, model);
        },
        _hasYesNoQuestion: () => this.modelService.doesCurrentUserModelEntryExist(this.abmsIndex, this.index).map(r => !r)
    });

    get model(): AbmsBoardSubspecialty {
        return this.stepScreenModel.dataModel;
    }

    get formErrors(): FormErrors {
        return this.stepScreenModel.formErrors;
    }

    handleCurrentlyCertifiedChange() {
        if (!this.model.currentlyCertified) this.model.certificationDate = undefined;
    }

    handleRecertifiedChange() {
        if (!this.model.recertified) this.model.recertificationDate = undefined;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/licenses-certifications/steps/board/abms-subspecialty/abms-board-subspecialty-screen.component.ts